module.exports = __webpack_public_path__ + "img/logo.cf129467.png";